import React from 'react'
import { useParams } from 'react-router-dom'
import { Row } from 'antd'
import moment from 'moment'
import Heading from '../../../../component/common/Heading'
import CRUDComponent from '../../../../component/common/CRUD-Component'
import CONSTANTS from '../../../../util/constant/CONSTANTS'

const ManuallyTracking = () => {
    const { id } = useParams()
    return (
        <>
            <div>
                <Heading>Manually Tracking</Heading>

                <Row>
                    <CRUDComponent
                        GET={{
                            API: CONSTANTS.API.Pet_Manually_tracking.getAll,
                            extraQuery: {
                                petId: id
                            },
                            DataModifier: (res, API, Setrefresh) => {
                                // console.log(res, "GET ALL ABCD");
                                return res?.map(data => {
                                    return {
                                        ...data,
                                        no: `PM${data?.id.toString().padStart(7, "0")}`,
                                        date: moment(data?.date).format("DD MMM YYYY"),

                                    }
                                })
                            },
                            column: CONSTANTS.TABLE.PETS_MANUALLY_TRACKING,
                        }}
                        isSearch={true}

                    />
                </Row>

            </div>
        </>
    )
}

export default ManuallyTracking